import { IonContent } from '@ionic/react';
import React from 'react';

import { CompanyDetailsFooter } from '@/components/CompanyDetailsFooter';
import { UiTypography } from '@/components/ui/Typography';
import { S3_BUCKET_URL } from '@/constants';
import { PAYWALL_NOTES } from '@/constants/campaign-notes';
import { useAccount } from '@/hooks/useAccount';
import { apiV1GetMeAuthRequest } from '@/modules/api';
import { webCampaign } from '@/modules/webCampaign';
import { LogoWithAppName } from '@/pages/Onboarding/components/LogoWithAppName';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useLayoutSelections } from '@/pages/Onboarding/hooks/useLayoutSelections';
import { useManLayoutSelections } from '@/pages/Onboarding/hooks/useManLayoutSelections';

import { StartEnjoyingButton } from './components/StartEnjoyingButton';
import { LogoContainer, SuccessPageStyles } from './WebVersion.styles';

const WebVersionVariant: React.FC = () => {
  const { user } = useAccount();
  const [authToken, setAuthToken] = React.useState<string | null>(null);
  const { ageGeneration, bodyShape, hairColor } = useLayoutSelections();
  const {
    ageGeneration: manAgeGeneration,
    bodyShape: manBodyShape,
    ethnicity,
  } = useManLayoutSelections();

  React.useEffect(() => {
    const fetchAuthToken = async () => {
      const auth = await apiV1GetMeAuthRequest();
      setAuthToken(auth.token);
    };
    fetchAuthToken();
  }, []);

  const getBackgroundImage = () => {
    if (webCampaign.setup.paywallImagesVariant === 'multigender') {
      if (user?.onboarding_data?.gender === 'male') {
        return `${S3_BUCKET_URL}/paywall/fast-pay-tab-man/${manAgeGeneration}/${ethnicity}_${manBodyShape}.png`;
      } else {
        return `${S3_BUCKET_URL}/paywall/v6/${ageGeneration}_${hairColor}_${bodyShape}.png`;
      }
    }
  };

  const handleStartEnjoyingClick = () => {
    if (authToken) {
      const url = webCampaign.getAuthUrl(authToken);
      window.open(url, '_blank');
    }
  };

  return (
    <SuccessPageStyles backgroundImage={getBackgroundImage()}>
      <IonContent>
        <div className={'image-container'} />
        <div className="content">
          {webCampaign.isPaywallLure() && (
            <LogoContainer>
              <LogoWithAppName withCaption={false} variant="white" />
            </LogoContainer>
          )}
          <OnboardingTitle>
            Congrats, your purchase
            <br /> was successful!
          </OnboardingTitle>

          <StartEnjoyingButton onClick={handleStartEnjoyingClick} />

          <div className="questions-email">
            <UiTypography variant="body-medium" align="center">
              If you have any questions - reach us at{' '}
              <a href={`mailto:${webCampaign.getLegalSupportEmail()}`}>
                {webCampaign.getLegalSupportEmail()}
              </a>
            </UiTypography>
          </div>

          {webCampaign.setup.paywallNotes.includes(
            PAYWALL_NOTES.SHOW_COMPANY_DETAILS_FOOTER,
          ) && <CompanyDetailsFooter noHorizontalPadding />}
        </div>
      </IonContent>
    </SuccessPageStyles>
  );
};

export default WebVersionVariant;
